import axios from '../../../../api/config'
import {
  getRulesAPI,
  getWordsAPI,
  getExamWordsAPI,
  createCompleteRecordAPI,
  createSubrecordAPI,
  createExamCompleteRecordAPI,
  createExamSubrecordAPI
} from '../../../../api/vocabularyAPI.js'
import {
  firstPracticedAPI
} from '@/api/authAPI'
import { shuffle } from '../../../../util/array'
import { roundDecimal } from '../../../../util/math'
import { MODES } from '../../../../components/Vocabulary/vocabularyMode'
import { getInformationFromOSS } from './functions'

const state = {
  wait: false,
  leave: false,
  ruleList: [],
  currentRule: null,
  mode: null, /** LEARNNEW, REVIEW, FORCEREVIEW, EXAMSIMULATION, EXAM */
  isUpgraded: false,
  hasForceReview: false,
  selectedInitSeq: 0,
  selectedBlockSize: 0,
  practiceTimes: 0,
  toStartTest: false,
  toStartPractice: false,
  wordList: [],
  /** 當次練習完整記錄的ID */
  completeRecordId: null,
  /** 全民英檢 */
  knownList: [],
  testWordList: [], // 全民英檢的單詞列表：concat(shuffle(knownList), shuffle(knownList))
  testJudgeResult: [], // 全民英檢結果，供 TestResultModal.vue 使用
  sortedTestJudgeResult: [], // 全民英檢結果，供 TestResultModal.vue 使用
  testCorrectCount: 0, // 全民英檢正確題數
  testScore: 0, // 全民英檢分數
  /** 一般學習 */
  unknownList: [],
  practiceWordListLength: 0,
  currentWordIndex: -1,
  currentWord: null,
  correctCount: 0,
  incorrectCount: 0,
  practiceJudgeResult: [],
  practiceMode: false,
  practiceWordSeq: 0
  // examReviewAfterFirstPractice: false
}

const getters = {
  knownListLength (state) {
    return state.knownList.length
  },
  unknownListLength (state) {
    return state.unknownList.length
  }
}

const mutations = {
  setWait (state, flag) {
    state.wait = flag
  },
  setLeave (state, flag) {
    state.leave = flag
  },
  resetAll (state) {
    state.leave = false
    state.knownList = []
    state.unknownList = []
    state.wordList = []
    state.toStartTest = false
    state.toStartPractice = false
    state.testWordList = []
    state.testJudgeResult = []
    state.testScore = 0
    state.testCorrectCount = 0
    state.currentWord = null
    state.currentWordIndex = -1
    state.correctCount = 0
    state.incorrectCount = 0
    state.practiceWordSeq = 0
    // state.examReviewAfterFirstPractice = false
  },
  setRules (state, rules) {
    state.ruleList = rules
    state.currentRule = state.ruleList.find(rule => rule.mode === 'LEARNNEW')
  },
  setRule (state, mode) {
    state.currentRule = state.ruleList.find(rule => rule.mode === mode)
  },
  setMode (state, mode) {
    state.mode = mode
  },
  setPracticeMode (state, practiceMode) {
    state.practiceMode = practiceMode
    console.log('set:', state.practiceMode)
  },
  setHasForceReview (state, flag) {
    state.hasForceReview = flag
  },
  setIsUpgraded (state, flag) {
    state.isUpgraded = flag
  },
  setSelectedInitSeq (state, value) {
    state.selectedInitSeq = value
  },
  setSelectedBlockSize (state, value) {
    state.selectedBlockSize = value
  },
  setPracticeTimes (state, value) {
    state.practiceTimes = value
  },
  setCompleteRecordId (state, id) {
    state.completeRecordId = id
  },
  setToStartTest (state, flag) {
    state.toStartTest = flag
    state.testJudgeResult = []
  },
  setToStartPractice (state, flag) {
    state.toStartPractice = flag
    state.practiceJudgeResult = []
  },
  setWordList (state, data) {
    state.wordList = data
  },
  setKnownListAndUnknownList (state, payload) {
    if (state.isUpgraded && MODES.NOTEXAM[0] === state.mode) { // 成人路线
      state.unknownList = state.wordList.filter(word => payload.selectedWords.includes(word.id))
      state.knownList = []
    } else if (state.isUpgraded && MODES.NOTEXAM[1] === state.mode) {
      state.knownList = state.wordList.filter(word => payload.selectedWords.includes(word.id))
      state.unknownList = []
    } else {
      state.knownList = state.wordList.filter(word => payload.selectedWords.includes(word.id))
      state.unknownList = state.wordList.filter(word => !payload.selectedWords.includes(word.id))
    }
    if (MODES.EXAM.includes(state.mode)) {
      switch (payload.currentExam.modeCode) {
        case 1:
        case 2:
        case 3:
          state.testWordList = shuffle(state.knownList)
          break
        case 4:
          state.testWordList = shuffle(state.knownList) // .concat(shuffle(state.knownList))
          break
      }
    } else {
      state.testWordList = shuffle(state.knownList).concat(shuffle(state.knownList))
    }
    state.practiceWordListLength = state.unknownList.length
  },
  /** 全民英檢 */
  setTestJudgeResult (state, payload) {
    const testWordList = state.testWordList.slice()
    const inputText = payload.data.inputText
    const modeCode = payload.currentExam.modeCode
    for (let i = 0; i < testWordList.length; i++) {
      let question = testWordList[i].meaning
      const defaultPronunciation = testWordList[i].us_pron && testWordList[i].us_pron.length > 0 ? testWordList[i].us_pron : testWordList[i].uk_pron
      if (MODES.EXAM.includes(state.mode)) {
        if (modeCode === 1 || modeCode === 3) {
          question = testWordList[i].meaning
        } else if (modeCode === 2) {
          question = defaultPronunciation
        } else if (modeCode === 3) {
          question = {
            meaning: testWordList[i].meaning,
            pronunciation: defaultPronunciation
          }
        } else if (modeCode === 4) {
          if (i >= testWordList.length / 2) {
            question = defaultPronunciation
          }
        }
      } else {
        if (i >= testWordList.length / 2) {
          question = defaultPronunciation
        }
      }
      state.testJudgeResult.push({
        seq: i + 1,
        id: testWordList[i].id,
        sequence: testWordList[i].sequence,
        question: question,
        correctAnswer: testWordList[i].word,
        inputAnswer: inputText[i] ? inputText[i] : '',
        correctOrNot: testWordList[i].word === inputText[i]
      })
      state.testCorrectCount += testWordList[i].word === inputText[i] ? 1 : 0
      if (testWordList[i].word !== inputText[i] &&
        !state.unknownList.find(word => word.word === testWordList[i].word)) {
        state.unknownList.push(testWordList[i])
      }
    }
    state.practiceWordListLength = state.unknownList.length
    state.sortedTestJudgeResult = [...new Set(state.testJudgeResult.map(obj => obj.sequence).slice(0))]
    state.sortedTestJudgeResult.sort((a, b) => a - b)
    state.testScore = roundDecimal((state.testCorrectCount / testWordList.length) * 100, 2)
  },
  setTestCorrectCount (state, value) {
    state.testCorrectCount = value
  },
  /** 一般學習 */
  setNextCurrentWord (state) {
    state.currentWordIndex += 1
    state.practiceWordSeq += 1
    state.currentWord = state.unknownList[state.currentWordIndex]
    state.practiceJudgeResult.push({
      seq: state.practiceWordSeq,
      id: state.currentWord.id,
      sequence: state.currentWord.sequence,
      word: state.currentWord.word,
      correctCount: 0,
      incorrectCount: 0,
      correctRate: 0
    })
  },
  setPreviousCurrentWord (state) {
    if (state.currentWordIndex > 0) {
      state.currentWordIndex -= 1
      state.practiceWordSeq += 1
      state.currentWord = state.unknownList[state.currentWordIndex]
      state.practiceJudgeResult.push({
        seq: state.practiceWordSeq,
        id: state.currentWord.id,
        sequence: state.currentWord.sequence,
        word: state.currentWord.word,
        correctCount: 0,
        incorrectCount: 0,
        correctRate: 0
      })
    }
  },
  setCorrect (state) {
    state.correctCount += 1
    state.practiceJudgeResult[state.currentWordIndex].correctCount += 1
    state.practiceJudgeResult[state.currentWordIndex].correctRate =
      state.practiceJudgeResult[state.currentWordIndex].correctCount /
      (state.practiceJudgeResult[state.currentWordIndex].correctCount +
      state.practiceJudgeResult[state.currentWordIndex].incorrectCount)
  },
  setIncorrect (state) {
    state.incorrectCount += 1
    state.practiceJudgeResult[state.currentWordIndex].incorrectCount += 1
    state.practiceJudgeResult[state.currentWordIndex].correctRate =
      state.practiceJudgeResult[state.currentWordIndex].correctCount /
      (state.practiceJudgeResult[state.currentWordIndex].correctCount +
      state.practiceJudgeResult[state.currentWordIndex].incorrectCount)
  },
  setTestWordListAfterPractice (state) {
    if (!state.isUpgraded || (state.isUpgraded && state.mode === MODES.FORCEREVIEW)) {
      if (state.mode === 'LEARNNEW' && state.currentRule.mode === 'LEARNNEW') {
        state.knownList = state.wordList.slice()
      } else if ((state.mode === 'REVIEW' && state.currentRule.mode === 'REVIEW') || (state.mode === MODES.FORCEREVIEW)) {
        state.knownList = state.unknownList.slice()
      }
    } else { // 成人路線
      state.knownList = state.unknownList.slice()
    }
    state.unknownList = []
    state.testWordList = shuffle(state.knownList).concat(shuffle(state.knownList))
  },
  resetPractice (state) {
    state.currentWordIndex = -1
    state.currentWord = 0
    state.correctCount = 0
    state.incorrectCount = 0
    state.unknownList = []
  }
  // setExamReviewAfterFirstPractice (state, flag) {
  //   state.examReviewAfterFirstPractice = flag
  // }
}

const actions = {
  getRules ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(getRulesAPI)
        .then((response) => {
          commit('setRules', response.data.practiceRules)
          commit('setIsUpgraded', response.data.isUpgraded)
          resolve('OK')
        }).catch((err) => {
          reject(err)
        })
    })
  },
  fetchWords ({ commit, state }, payload) {
    commit('setWait', true)
    commit('setLeave', false)
    if (payload.initSeq && payload.blockSize) {
      commit('setSelectedInitSeq', payload.initSeq)
      commit('setSelectedBlockSize', payload.blockSize)
    }
    return new Promise((resolve, reject) => {
      // axios.post(getWordsAPI, (state.isUpgraded && state.mode === MODES.FORCEREVIEW)
      axios.post(getWordsAPI, (state.mode === MODES.FORCEREVIEW)
        ? {
          glossary: payload.glossary,
          wordList: payload.upgradedUserForceReviewWordList
        }
        : {
          glossary: payload.glossary,
          beginFrom: payload.initSeq,
          blockSize: payload.blockSize
        }).then(async (res) => {
        let wordList = res.data.message.slice()
        wordList = await getInformationFromOSS(wordList)
        commit('setWordList', wordList)
        commit('setWait', false)
        resolve(res.data.message)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  fetchExamWords ({ commit, rootState, state, dispatch }, payload) {
    commit('setWait', true)
    commit('setLeave', false)
    const mode = state.mode
    return new Promise((resolve, reject) => {
      axios.get(`${getExamWordsAPI}/${rootState.exam.currentExam.id}?mode=${mode}`)
        .then(async (res) => {
          const wordList = await getInformationFromOSS(res.data.message.slice())
          commit('setWordList', wordList)
          commit('setKnownListAndUnknownList', {
            selectedWords: wordList.slice().map(word => word.id),
            currentExam: rootState.exam.currentExam
          })
          commit('setWait', false)
          dispatch('createExamCompleteRecord')
            .then((res) => {
              resolve()
            })
        })
        // .catch((err) => {
        //   if (err.response.status === 400 &&
        //     err.response.data.message === 'LIMITEXCEEDED') {
        //     commit('setWait', false)
        //     reject(err)
        //   }
        // })
    })
  },
  createExamCompleteRecord ({ commit, rootState }) {
    commit('setWait', true)
    return new Promise((resolve, reject) => {
      axios.post(createExamCompleteRecordAPI, {
        examId: rootState.exam.currentExam.id,
        mode: state.mode
      }).then((res) => {
        commit('setCompleteRecordId', res.data.message.id)
        commit('setWait', false)
        resolve()
      })
    })
  },
  appendToKnownListAndUnknownList ({ commit, rootState, state }, payload) {
    commit('setWait', true)
    return new Promise((resolve) => {
      commit('setPracticeTimes', payload.practiceTimes)
      commit('setKnownListAndUnknownList', payload)
      let selectedWords = []
      if (state.isUpgraded) {
        if (state.mode === MODES.NOTEXAM[0]) {
          selectedWords = state.unknownList
        } else if (state.mode === MODES.NOTEXAM[1]) {
          selectedWords = state.knownList
        }
      } else {
        selectedWords = state.wordList
      }
      axios.post(createCompleteRecordAPI, {
        glossary: rootState.glossary.chosenGlossary,
        book: rootState.glossary.chosenBook,
        lesson: rootState.glossary.chosenLesson,
        beginFrom: state.selectedInitSeq,
        blockSize: state.isUpgraded ? state.unknownList.length : state.selectedBlockSize,
        mode: state.mode,
        selectedWords: selectedWords,
        skipTyping: state.practiceMode
      }).then((res) => {
        commit('setCompleteRecordId', res.data.message.id)
        commit('setWait', false)
        resolve()
      })
    })
  },
  uploadTestResult ({ commit, rootState, state }, payload) {
    return new Promise((resolve) => {
      commit('setTestJudgeResult', {
        data: payload,
        currentExam: rootState.exam.currentExam
      })
      commit('setWait', true)
      let isCompleted = false
      let api = ''
      if (state.mode === 'LEARNNEW') {
        if (state.isUpgraded) {
          isCompleted = state.testCorrectCount === state.testWordList.length
        } else {
          isCompleted = state.testCorrectCount === state.wordList.length * 2 // state.selectedBlockSize * 2 // state.testWordList.length
        }
        api = createSubrecordAPI
      } else if (state.mode === 'REVIEW' || state.mode === MODES.FORCEREVIEW) {
        isCompleted = (state.unknownList.length === 0) && (state.testCorrectCount / state.testWordList.length === 1)
        api = createSubrecordAPI
      } else if (state.mode === 'EXAMSIMULATION') {
        isCompleted = true
        api = createExamSubrecordAPI
      } else if (state.mode === 'EXAM') {
        isCompleted = true
        api = createExamSubrecordAPI
      }
      axios.post(api, {
        mode: state.mode,
        completeRecord: {
          id: state.completeRecordId,
          isCompleted: isCompleted
        },
        testRecord: {
          usedTime: payload.timeElapsed / 1000,
          correct: state.testCorrectCount,
          incorrect: state.testWordList.length - state.testCorrectCount,
          correctRate: state.testCorrectCount / state.testWordList.length,
          isTestOrPractice: true, // test
          words: {
            array: state.testJudgeResult.map((record, idx) => {
              if (MODES.NOTEXAM.includes(state.mode) || MODES.FORCEREVIEW === state.mode || (MODES.EXAM.includes(state.mode) && rootState.exam.currentExam.modeCode === 4)) {
                if (idx < state.testWordList.length / 2) {
                  return { ...record, question: 'TRANSLATION' }
                } else {
                  return { ...record, question: 'LISTENING' }
                }
              } else if (MODES.EXAM.includes(state.mode)) {
                switch (rootState.exam.currentExam.modeCode) {
                  case 1: return { ...record, question: 'TRANSLATION' }
                  case 2: return { ...record, question: 'LISTENING' }
                  case 3: return { ...record, question: 'TRANSLATION+LISTENING' }
                }
              }
            })
          }
        }
      }).then((res) => {
        if (localStorage.practicedToday === 'false') {
          axios.post(firstPracticedAPI, {
            email: localStorage.email
          }).then(() => {
            localStorage.practicedToday = true
          })
        }
        commit('setTestCorrectCount', 0)
        commit('setWait', false)
        if (res.data.message === 'certificate available') {
          resolve('certificate available')
        } else {
          resolve()
        }
      })
    })
  },
  uploadPracticeResult ({ commit, state }, payload) {
    commit('setTestWordListAfterPractice')
    commit('setWait', true)
    const api = createSubrecordAPI // state.mode === 'EXAMREVIEW' ? createExamSubrecordAPI : createSubrecordAPI
    const completeRecord = {
      id: state.completeRecordId,
      isCompleted: false
    }
    // state.mode === 'EXAMREVIEW' ?
    // {
    //   id: state.completeRecordId,
    //   isCompleted: false
    // }
    // : {
    //   id: state.completeRecordId,
    //   isCompleted: false
    //   // blockSize: state.isUpgraded ? state.testWordList.length / 2 : state.selectedBlockSize
    // }
    axios.post(api, {
      mode: state.mode,
      completeRecord: completeRecord,
      testRecord: {
        usedTime: payload.timeElapsed / 1000,
        correct: state.correctCount,
        incorrect: state.incorrectCount,
        correctRate: state.correctCount / (state.correctCount + state.incorrectCount),
        isTestOrPractice: false, // practice
        words: {
          array: state.practiceJudgeResult
        }
      }
    }).then((response) => {
      if (localStorage.practicedToday === 'false') {
        axios.post(firstPracticedAPI, {
          email: localStorage.email
        }).then(() => {
          localStorage.practicedToday = true
        })
      }

      // if (!state.examReviewAfterFirstPractice) {
      //   commit('setExamReviewAfterFirstPractice', true)
      // }
      commit('setWait', false)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
